import { render, staticRenderFns } from "./RecStorageAddr.vue?vue&type=template&id=7924fb17&scoped=true&"
import script from "./RecStorageAddr.vue?vue&type=script&lang=js&"
export * from "./RecStorageAddr.vue?vue&type=script&lang=js&"
import style0 from "./RecStorageAddr.vue?vue&type=style&index=0&id=7924fb17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924fb17",
  null
  
)

export default component.exports